import Data from 'data';
import Locale from 'data/locale';
import { isSubType } from 'logic/itemTypes';
import { hirelingWeaponType } from 'logic/stateReducers';
import { skillCalc } from './calc';

const playerCode = {
  ama: 'AM',
  sor: 'SO',
  nec: 'NE',
  pal: 'PA',
  bar: 'BA',
  dru: 'DZ',
  ass: 'AI',
};

const animWeapons = ['hth', '1ht', '2ht', '1hs', '2hs', 'bow', 'xbw', 'stf', '1js', '1jt', '1ss', '1st', 'ht1', 'ht2'];
//const plrModes = ['DT', 'NU', 'WL', 'RN', 'GH', 'TN', 'TW', 'A1', 'A2', 'BL', 'SC', 'TH', 'KK', 'S1', 'S2', 'S3', 'S4', 'DD', 'SQ', 'KB'];
const monModes = ['DT', 'NU', 'WL', 'GH', 'A1', 'A2', 'BL', 'SC', 'S1', 'S2', 'S3', 'S4', 'DD', 'KB', 'xx', 'RN'];
const animTypes = {
  GH: 'fhr',
  A1: 'ias',
  A2: 'ias',
  BL: 'fbr',
  SC: 'fcr',
  TH: 'ias',
  KK: 'ias',
  S1: 'ias',
  S2: 'ias',
  S3: 'ias',
  S4: 'ias',
};
const animSequences = [
  null,
  {type: 'ias', data: [[13,8],[18,3,9,15],[21,3,10,17]]}, // jab
  {type:  null, data: [[14,7],null,null,[7,3],[8,4]]},
  {type:  null, data: [[14,7],null,null,[16,11]]},
  {type:  null, data: [[15,11],[15,11],[15,11],[15,11],[15,11],null,null,[15,11]]}, // charge
  {type:  null, data: [[14,7],null,null,[6,2]]},
  {type:  null, data: [[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10]]}, // inferno
  {type:  null, data: [[13,8],null,null,null,null,[13,5],[20,11]]},
  {type: 'ias', data: [[13,8],[21,13],[24,15]]}, // impale
  {type:  null, data: [[13,8],[16,13],[16]]},
  {type: 'ias', data: [[8,3,7],[8,3,7],[8,3,7],[8,3,7],[8,3,7],null,null,[8,3,7],[8,3,7],[8,3,7],[8,3,7],[8,3,7],[8,3,7],[8,3,7]]}, // whirlwind
  {type: 'ias', data: [[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9],[17,4,9]]}, // double swing
  {type: 'fcr', data: [[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7],[19,7]]}, // lightning
  {type:  null, data: [[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14],[15,5,11,14]]}, // leap
  {type:  null, data: [[22,5,11,16],[25,5,11,16],[28,5,11,18],[25,5,11,16],[27,5,11,17],null,null,[28,5,11,18],[22,5,11,16],[22,5,11,16],[22,5,11,16],[22,5,11,16],[22,5,11,16],[22,5,11,16]]}, // leap attack
  {type: 'ias', data: [[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9],[12,5,9]]}, // double throw
  {type: 'ias', data: [[12,6],null,null,null,null,null,null,null,null,null,null,null,[12,6],[16,6,10]]}, // claw attacks
  {type:  null, data: [[19,7,11,17],[19,7,11,17],[19,7,11,17],[19,7,11,17],[19,7,11,17],[19,7,11,17],[19,7,11,17],[19,7,11,17],null,null,null,null,[19,7,11,17],[19,7,11,17]]},
  {type: 'fcr', data: [[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10],[15,10]]}, // arctic blast
  {type:  null, data: [[20,4,8,13],[20,4,8,13],[20,4,8,13],[20,4,8,13],[20,4,8,13],[20,4,8,13],[20,4,8,13],[20,4,8,13],null,null,null,null,[20,4,8,13],[20,4,8,13]]},
  {type:  null, data: [[17,8,10,12,14],[17,8,10,12,14],[17,8,10,12,14],[17,8,10,12,14],[17,8,10,12,14],[17,8,10,12,14],[17,8,10,12,14],null,null,null,null,null,[17,8,10,12,14],[17,8,10,12,14]]},
  {type:  null, data: [[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14],[23,9,14]]}, // dragon flight
  {type:  null, data: [[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13],[16,13]]},
  {type:  null, data: [[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12],[19,12]]}, // blade fury
];
function getWeaponClass(stats) {
  const w1 = Data.items[stats.weapon1?.baseitem];
  const w2 = Data.items[stats.weapon2?.baseitem];
  if (!w1) {
    const monster = Data.monsters[stats.class];
    return monster?.basew || 'hth';
  }
  if (stats.weapon1.twohanded) return w1['2handedwclass'] || w1.wclass || 'hth';
  if (!w2 || stats.unit === 'mercenary') return w1.wclass || 'hth';
  if (w1.wclass === '1hs') {
    if (w2.wclass === '1hs') return '1ss';
    if (w2.wclass === '1ht') return '1js';
  } else if (w1.wclass === '1ht') {
    if (w2.wclass === '1hs') return '1st';
    if (w2.wclass === '1ht') return '1jt';
  } else if (w1.wclass === 'ht1') {
    if (w2.wclass === 'ht1') return 'ht2';
  }
  return w1.wclass || 'hth';
}

function getUnitCode(stats) {
  const moncode = monster => monster && {name: Locale.strings[monster.namestr], code: monster.code};

  if (stats.base.state) {
    for (const id in stats.base.state) {
      const state = Data.states[id];
      if (state?.gfxtype === 1) {
        const monster = Data.monsterById[state.gfxclass];
        if (monster) return moncode(monster);
      }
    }
  }

  if (stats.unit === 'player') {
    return {name: Locale.strings[Data.classNames[stats.class]], code: playerCode[stats.class]};
  } else if (stats.unit === 'mercenary') {
    return moncode(Data.monsterById[Data.hireling[stats.class]?.[0]?.class]);
  } else {
    return moncode(Data.monsters[stats.class]);
  }
}

const _startFrame = {'hth': 1, '1hs': 2, '2hs': 2, '1ht': 2, '2ht': 2, 'stf': 2};

function startFrame(unit, mode, wclass) {
  if ((unit === 'AM' || unit === 'SO') && (mode === 'A1' || mode === 'A2')) {
    return _startFrame[wclass] || 0;
  }
  return 0;
}

const weaponClassTag = item => item ? `${item.wclass}|${item['2handedwclass']}` : 'hth|hth';

function weaponSpeedList(filter, wsm0) {
  const wsm = new Set([wsm0]);
  for (const item of Object.values(Data.weapons)) {
    if (filter(item)) {
      wsm.add(item.speed || 0);
    }
  }
  return [...wsm].sort((a, b) => b - a);
}
function weaponList(filter, wsm) {
  return Object.keys(Data.weapons).filter(id => filter(Data.weapons[id]) && (Data.weapons[id].speed || 0) === wsm);
}
const weaponFilterSkill = (skill, wc0) => function(item) {
  if (weaponClassTag(item) !== wc0) return false;
  if (skill.weapsel === 1) {
    if (skill.itypeb1) {
      if (![skill.itypeb1, skill.itypeb2, skill.itypeb3].some(t => t && isSubType(item.type, t))) return false;
      if ([skill.etypeb1, skill.etypeb2].some(t => t && isSubType(item.type, t))) return false;
    }
  } else {
    if (skill.itypea1) {
      if (![skill.itypea1, skill.itypea2, skill.itypea3].some(t => t && isSubType(item.type, t))) return false;
      if ([skill.etypea1, skill.etypea2].some(t => t && isSubType(item.type, t))) return false;
    }
  }
  return true;
};
const weaponFilterMerc = merc => function(item) {
  if (!merc) return false;
  return hirelingWeaponType(merc.class, item.type);
};

// most skills - no basic attack, no rollback, no special cases
export class AnimationCalculator {
  minaccel = 15;
  maxaccel = 175;

  weaponFilter = () => false;

  constructor(stats, skill, ...params) {
    this.skill = skill;
    this.stats = stats;
    this._params = params;

    const unitInfo = getUnitCode(stats);
    this.unitName = unitInfo?.name;
    const unit = this.unit = unitInfo?.code.toUpperCase();
    this.wclass = getWeaponClass(stats)?.toLowerCase();
    this.wereform = unit === 'TG' || unit === '40';

    if (stats.unit !== 'player') {
      const monster = (stats.unit === 'mercenary' ?
        Data.monsterById[Data.hireling[stats.class]?.[0]?.class] :
        Data.monsters[stats.class]);
      if (monster && !monster.inventory) {
        this.noinventory = true;
      }
    }

    if (!this.init(...params)) {
      this.error = true;
    }

    if (this.type === 'ias' && this.wereform && !Data.info.patch) {
      this.type = 'oias';
      // wereforms pre 2.4.2
      // 'calculate' human A1 frames with 1h wclass
      const weapon = this.stats.weapon1;
      const wclass1 = Data.items[weapon.baseitem]?.wclass?.toUpperCase() || 'HTH';
      const human = playerCode[this.stats.class];
      const humanData = Data.animData(`${human}A1${wclass1}`) || Data.animData(`${human}A1HTH`);
      const neutral = Data.animData(`${unit}NUHTH`);
      if (!neutral || !humanData) return null;
      const hframes = Math.floor(256 * humanData[0] / Math.floor(humanData[1] * (100 + (weapon.weaponias || 0) - weapon.weaponspeed) / 100));
      // and apply them to wereform neutral animation mode somehow
      this.speed = Math.floor(256 * neutral[0] / hframes);
    }
  }

  init(...params) {
    const {unit, stats, skill, wclass} = this;

    let mode = null;

    if (stats.unit === 'player' || skill.id == null) {
      mode = this.mode = skill.anim;
      if (mode === 'SQ') {
        const seq = animSequences[skill.seqnum];
        if (seq) {
          this.type = seq.type;
          this.sequence = seq.data[animWeapons.indexOf(wclass)] || seq.data[0];
          if (!this.sequence) return false;
        }
        mode = 'GH';
      } else {
        this.type = animTypes[mode];
      }
    } else {
      const monster = (stats.unit === 'mercenary' ?
        Data.monsterById[Data.hireling[stats.class]?.[0]?.class] :
        Data.monsters[stats.class]);
      if (!monster) return false;
      const index = [...Array(8)].findIndex((_, i) => monster[`skill${i + 1}`] === skill.id);
      if (index >= 0) {
        mode = this.mode = monster[`sk${index + 1}mode`];
        const seq = Data.monseq[mode];
        if (seq) {
          this.mode = 'xx';
          mode = 'GH';
          this.sequence = seq;
          this.type = 'ias';
        } else {
          this.type = animTypes[mode];
        }
      } else {
        if (monster.code === 'k9') {
          // special logic for shadow warrior/master
          mode = this.mode = skill.monanim;
          this.type = animTypes[mode];
        } else if (stats.unit === 'mercenary') {
          const merc = Data.hireling[stats.class]?.[0];
          if (!merc) return false;
          const index = [...Array(6)].findIndex((_, i) => merc[`skill${i + 1}`] === skill.id);
          if (index < 0) return false;
          mode = this.mode = monModes[merc[`mode${index + 1}`]];
          this.type = animTypes[mode];
        } else {
          return false;
        }
      }
    }
    let data = this.data = Data.animData(`${unit}${mode}${wclass.toUpperCase()}`) || Data.animData(`${unit}${mode}HTH`);
    if (!data && this.mode === 'xx') {
      mode = 'NU';
      data = this.data = Data.animData(`${unit}${mode}${wclass.toUpperCase()}`) || Data.animData(`${unit}${mode}HTH`);
    }
    if (!data) return false;
    this.speed = data[1];

    if (this.type === 'ias') {
      const weapon = this.weapon = (skill.weapsel === 1 && stats.weapon2) || stats.weapon1;
      this.wsm = weapon.weaponspeed;
      this.baseaccel = 100 + (weapon.attackrate || 0) - this.wsm;
      if (this.mode === 'SQ') {
        this.baseaccel -= 30;
      }
      this.varaccel = weapon.item_fasterattackrate || 0;

      if (stats.unit === 'player' && (unit !== 'TG' && unit !== '40')) {
        const wc = weaponClassTag(Data.items[weapon.baseitem]);
        this.weaponFilter = weaponFilterSkill(skill, wc);
      } else if (stats.unit === 'mercenary') {
        this.weaponFilter = weaponFilterMerc(Data.hireling[stats.class]?.[0]);
      }
      this.wsmlist = (this.noinventory ? [this.wsm] : weaponSpeedList(this.weaponFilter, this.wsm));
      if (this.wereform) {
        this.maxaccel = 250;
      }
    } else if (this.type === 'fcr') {
      this.baseaccel = 100;
      this.varaccel = stats.base.item_fastercastrate || 0;
      this.maxaccel = 175;
    } else if (this.type === 'fbr') {
      this.baseaccel = 50;
      this.varaccel = stats.base.item_fasterblockrate || 0;
      this.maxaccel = 50 + Math.floor(120 * 155 / (120 + 155));
    } else if (this.type === 'fhr') {
      this.baseaccel = 50;
      this.varaccel = stats.base.item_fastergethitrate || 0;
      this.maxaccel = 50 + Math.floor(120 * 594 / (120 + 594));
    } else {
      this.baseaccel = 100;
      this.varaccel = 0;
      this.minaccel = this.baseaccel;
      this.maxaccel = this.baseaccel;
    }
    this.delay = skillCalc(skill, skill.delay, stats, stats.skills[skill.id]);
    if ((stats.unit !== 'player' && stats.unit !== 'mercenary' && stats.unit !== 'monster') && this.type === 'ias') {
      this.petdelay = 15;
    }

    if (this.type === 'ias' && this.wereform && Data.info.patch) {
      // wereforms post 2.4.2
      const weapon = this.stats.weapon1;
      const wclass1 = Data.items[weapon.baseitem]?.wclass?.toUpperCase() || 'HTH';
      const human = playerCode[this.stats.class];
      const humanData = Data.animData(`${human}A1${wclass1}`) || Data.animData(`${human}A1HTH`);
      const wereData = Data.animData(`${unit}A1${wclass.toUpperCase()}`) || Data.animData(`${unit}A1HTH`);
      if (!humanData || !wereData) return false;
      this.speed = humanData[1];
      this.start = startFrame(human, mode, wclass1);
      this.wereformFactor = wereData[0] / humanData[0];
    } else {
      this.start = startFrame(unit, mode, wclass);
    }

    return this.init2(...params);
  }

  init2() {
    const {unit, data, sequence, start, wereformFactor} = this;

    // frames of interest - action frames and total length
    const foi = this.foi = sequence ? sequence.slice(1) : [];
    if (!sequence) {
      if (data[2] >= 0) foi.push(data[2]);
      if (data[3] >= 0) foi.push(data[3]);
    }
    this.hits = foi.length;
    this.foinames = foi.map((_, i) => foi.length > 1 ? `af${i + 1}` : 'af');
    const frames = sequence ? sequence[0] : data[0];
    foi.push(frames);
    if (this.delay) this.foinames.push('delay');
    this.foinames.push(this.delay ? 'total' : 'length');
    if (this.petdelay) this.foinames.push('delay');

    const skip = (this.mode === 'SQ' || this.mode === 'xx' ? 0 : 1);
    if (this.skill.srvdofunc === 120 && unit === '40' && !Data.info.patch) {
      // feral rage weird calc
      // after hitting action frame the step is doubled
      this._frames = accel => {
        let step = Math.floor(this.speed * accel / 100);
        if (wereformFactor) step = Math.floor(step * wereformFactor);
        const f1 = Math.ceil(256 * (this.foi[0] - start) / step);
        // there's only one action frame
        return [f1, f1 + Math.ceil((256 * (frames - start) - step * f1) / (step * 2)) - skip];
      };
    } else if (this.delay) {
      this._frames = accel => {
        let step = Math.floor(this.speed * accel / 100);
        if (wereformFactor) step = Math.floor(step * wereformFactor);
        const result = [Math.ceil(256 * (this.foi[0] - start) / step)];
        result.push(this.delay);
        result.push(Math.max(result[0] + this.delay, Math.ceil(256 * (frames - start) / step) - skip));
        return result;
      };
    } else {
      this._frames = accel => {
        let step = Math.floor(this.speed * accel / 100);
        if (wereformFactor) step = Math.floor(step * wereformFactor);
        const result = this.foi.map((f, i) => Math.ceil(256 * (f - start) / step) - (i === this.foi.length - 1 ? skip : 0));
        if (this.petdelay) result.push(this.petdelay);
        return result;
      };
    }

    return true;
  }

  calculate() {
    if (this.error) return null;
    const {baseaccel, varaccel} = this;

    const dr_accel = 120 * varaccel / (120 + varaccel) | 0;
    const accel = this.accel = Math.min(this.maxaccel, Math.max(this.minaccel, baseaccel + dr_accel));
    if (this.type === 'ias' || this.type === 'oias') {
      const speeds = this.wsmlist;
      const min = speeds[speeds.length - 1], max = speeds[0], wsm = this.wsm;
      let minvar = 0;
      if (this.type === 'oias' && this.weapon?.weaponias) {
        minvar = Math.floor(120 * this.weapon.weaponias / (120 + this.weapon.weaponias));
      }
      this.minaccel = Math.max(this.minaccel, (baseaccel + wsm) - max + minvar);
      this.maxaccel = Math.min(this.maxaccel, (baseaccel + wsm) - min + 119);
    } else {
      this.minaccel = Math.max(this.minaccel, baseaccel);
      this.maxaccel = Math.min(this.maxaccel, baseaccel + 119);
    }

    this.result = this._frames(accel);
    this.fpa = this.result[this.result.length - (this.petdelay ? 2 : 1)] + (this.petdelay || 0);

    const minResult = this._frames(this.minaccel);
    const maxResult = this._frames(this.maxaccel);
    if (minResult.every((v, i) => v === maxResult[i])) {
      this.maxaccel = this.minaccel;
    }

    if (this.wereform && !Data.info.patch) {
      const wereform = (this instanceof RollbackAnimationCalculator ? (
        new WereformRollbackCalculator(this.stats, this.skill, ...this._params)
      ) : (
        new WereformCalculator(this.stats, this.skill)
      )).calculate();
      if (wereform) {
        if (this.minaccel >= this.maxaccel) {
          return wereform;
        } else {
          return [this, wereform];
        }
      }
    }

    return this;
  }

  reqparams(minaccel, maxaccel, delta=0) {
    const mindiff = minaccel - (this.baseaccel + (this.wsm || 0));
    const maxdiff = maxaccel - (this.baseaccel + (this.wsm || 0));
    const v0 = Math.floor(120 * delta / (120 + delta));
    return (this.wsmlist || [this.wsm || 0]).map(wsm => {
      const A = mindiff + wsm, B = maxdiff + wsm;
      if (B < v0 || A >= 120) {
        return -1;
      } else {
        return Math.max(0, Math.ceil(120 * A / (120 - A)) - delta);
      }
    });
  }

  simpleTable() {
    const {minaccel, maxaccel, _frames} = this;
    const result = [];
    for (let accel = minaccel; accel <= maxaccel; ++accel) {
      const frames = _frames(accel);
      const fpa = frames[frames.length - 1];
      const last = result[result.length - 1];
      if (!last || fpa < last[0]) {
        result.push([fpa, this.reqparams(accel, accel)[0]]);
      } else if (last && last[1] < 0) {
        last[1] = this.reqparams(accel, accel)[0];
      }
    }
    return result;
  }

  fullTable(delta=0) {
    const {minaccel, maxaccel, compress, _frames} = this;
    if (this.type === 'oias' && !delta) {
      delta = this.weapon?.weaponias || 0;
    }
    const result = [];
    for (let accel = minaccel; accel <= maxaccel; ++accel) {
      const frames = _frames(accel);
      const last = result[result.length - 1];
      if (!last || frames.some((f, i) => f !== last.frames[i])) {
        result.push({frames, minaccel: accel, maxaccel: accel});
      } else if (last) {
        last.maxaccel = accel;
      }
    }
    let foinames = this.foinames;
    if (compress) {
      let lastHit = 1, curHit = 1, remain = compress;
      foinames = foinames.slice();
      for (let i = 1; i < remain; ++i) {
        ++curHit;
        if (result.every(row => row.frames[i] === row.frames[i - 1])) {
          result.forEach(row => row.frames.splice(i, 1));
          foinames.splice(i, 1);
          foinames[--i] = `hit${lastHit}-${curHit}`;
          remain -= 1;
        } else {
          lastHit = curHit;
        }
      }
    }
    for (const res of result) {
      res.params = this.reqparams(res.minaccel, res.maxaccel, delta);
    }
    return [foinames, result];
  }

  weaponList(wsm) {
    return weaponList(this.weaponFilter, wsm);
  }
}

class MainHandCalculator extends AnimationCalculator {
  init() {
    const {unit, stats, wclass, wereform} = this;

    this.mode = 'A1';
    this.type = 'ias';

    const r1w = Data.animData(`${unit}A1${wclass.toUpperCase()}`);
    const r1 = r1w || Data.animData(`${unit}A1HTH`);
    if (!r1) return false;
    const r2 = !wereform && unit === 'player' && (Data.animData(`${unit}A2${wclass.toUpperCase()}`) || (!r1w && Data.animData(`${unit}A2HTH`)));
    const hasr2 = r2 && (r2[0] !== r1[0] || r2[1] !== r1[1]);

    if (stats.unit !== 'player' && stats.unit !== 'mercenary' && stats.unit !== 'monster') {
      this.petdelay = 15;
    }

    this.speed = r1[1];

    const weapon = this.weapon = stats.weapon1;
    this.wsm = weapon.weaponspeed;
    this.baseaccel = 100 + (weapon.attackrate || 0) - this.wsm;
    this.varaccel = weapon.item_fasterattackrate || 0;

    if (stats.unit === 'player' && !wereform) {
      const wc = weaponClassTag(Data.items[weapon.baseitem]);
      this.weaponFilter = weaponFilterSkill(this.skill, wc);
    } else if (stats.unit === 'mercenary') {
      this.weaponFilter = weaponFilterMerc(Data.hireling[stats.class]?.[0]);
    }
    this.wsmlist = (this.noinventory ? [this.wsm] : weaponSpeedList(this.weaponFilter, this.wsm));

    this.foinames = (hasr2 ? ['r1', 'r2', 'average'] : ['frames']);
    if (this.petdelay) this.foinames.push('delay');
    this.hits = 1;

    const start = startFrame(unit, 'A1', wclass);
    this._frames = accel => {
      const fr1 = Math.ceil(256 * (r1[0] - start) / Math.floor(this.speed * accel / 100)) - 1;
      const result = [fr1];
      if (hasr2) {
        const fr2 = Math.ceil(256 * (r2[0] - start) / Math.floor(r2[1] * accel / 100)) - 1;
        result.push(fr2);
        result.push((fr1 + fr2) / 2);
      }
      if (this.petdelay) result.push(this.petdelay);
      return result;
    };

    return true;
  }
}

class OffHandCalculator extends AnimationCalculator {
  init() {
    const {unit, stats, wclass} = this;

    this.mode = (unit === 'AI' ? 'S4' : (unit === '0A' ? 'A2' : 'S3'));
    this.type = 'ias';

    const data = Data.animData(`${unit}${this.mode}${wclass.toUpperCase()}`) || Data.animData(`${unit}${this.mode}HTH`);
    if (!data) return false;

    this.speed = data[1];

    const weapon = this.weapon = stats.weapon2;
    this.wsm = weapon.weaponspeed;
    this.baseaccel = 100 + (weapon.attackrate || 0) - this.wsm;
    this.varaccel = weapon.item_fasterattackrate || 0;
    this.wsmlist = [this.wsm];

    this.foinames = ['frames'];
    this.hits = 1;

    this._frames = accel => [Math.ceil(256 * data[0] / Math.floor(data[1] * accel / 100)) - 1];

    return true;
  }
}

class MainHandBasicCalculator extends AnimationCalculator {
  init() {
    const {unit, stats, wclass} = this;

    this.mode = 'A1';
    this.type = 'ias';

    const data = Data.animData(`${unit}${this.mode}${wclass.toUpperCase()}`) || Data.animData(`${unit}${this.mode}HTH`);
    if (!data) return false;

    this.speed = data[1];

    const weapon = this.weapon = stats.weapon1;
    this.wsm = weapon.weaponspeed;
    this.baseaccel = 100 + (weapon.attackrate || 0) - this.wsm;
    this.varaccel = weapon.item_fasterattackrate || 0;
    this.wsmlist = [this.wsm];

    this.foinames = ['frames'];
    this.hits = 1;

    const start = startFrame(unit, 'A1', wclass);
    this._frames = accel => [Math.ceil(256 * (data[0] - start) / Math.floor(data[1] * accel / 100)) - 1];

    return true;
  }
}

class DualWieldCalculator {
  constructor(stats, mainhand, offhand, average) {
    this.mainhand = mainhand;
    this.offhand = offhand;
    this.average = average;

    mainhand.wsmlist = [mainhand.wsm];
    offhand.wsmlist = [offhand.wsm];
    this.hits = 1;
    this.type = 'oias';

    if (average) {
      this.foinames = ['frames'];
    } else {
      this.foinames = ['r1'];
      if (mainhand.foinames.length > 1) this.foinames.push('r2');
      this.foinames.push('l1', 'average');
    }

    // accel = off-weapon IAS for us
    this.minaccel = 0;
    this.maxaccel = 9999;
  }

  calculate() {
    if (!this.mainhand.calculate()) return null;
    if (!this.offhand.calculate()) return null;

    if (this.average) {
      this._combine = (mh, oh) => [Math.ceil((mh[mh.length - 1] + oh[oh.length - 1]) / 2)];
    } else {
      this._combine = (mh, oh) => {
        const out = mh.slice();
        if (out.length > 1) out.pop();
        out.push(oh[0], (mh[mh.length - 1] + oh[0]) / 2);
        return out;
      };
    }

    const weapon = this.mainhand.weapon;
    this.accel = (weapon.item_fasterattackrate || 0) - (weapon.weaponias || 0);
    this.result = this._combine(this.mainhand.result, this.offhand.result);
    this.fpa = this.result[this.result.length - 1];
    return this;
  }

  fullTable() {
    const getTable = wpn => wpn.fullTable(wpn.weapon.weaponias || 0)[1].filter(row => row.params[0] >= 0);
    const t1 = getTable(this.mainhand);
    const t2 = getTable(this.offhand);

    const result = [];
    let i1 = 0, i2 = 0;
    while (i1 < t1.length && i2 < t2.length) {
      const n1 = (i1 + 1 < t1.length ? t1[i1 + 1].params[0] : Infinity);
      const n2 = (i2 + 1 < t2.length ? t2[i2 + 1].params[0] : Infinity);
      const ias = Math.max(t1[i1].params[0], t2[i2].params[0]);
      result.push({
        frames: this._combine(t1[i1].frames, t2[i2].frames),
        minaccel: ias,
        maxaccel: Math.min(n1, n2) - 1,
        params: [ias],
      });
      if (n1 === n2) {
        i1 += 1;
        i2 += 1;
      } else if (n1 < n2) {
        i1 += 1;
      } else {
        i2 += 1;
      }
    }

    return [this.foinames, result];
  }

  weaponList() {
    return [];
  }
}
export class RollbackAnimationCalculator extends AnimationCalculator {
  init2(hits, rollback) {
    const {data, sequence, start, wereformFactor} = this;

    this.hits = hits;
    this.foinames = [...Array(hits)].map((_, i) => `hit${i + 1}`);
    this.foinames.push('total');

    const af = sequence ? sequence[1] : data[2];
    if (!af || af < 0) return false;
    const frames = sequence ? sequence[0] : data[0];

    this._frames = accel => {
      let pos = start;
      const result = [];
      let total = 0;
      let step = Math.floor(this.speed * accel / 100);
      if (wereformFactor) step = Math.floor(step * wereformFactor);
      for (let i = 0; i < hits - 1; ++i) {
        const cur = Math.ceil(256 * (af - pos) / step);
        result.push(cur);
        total += cur;
        pos = Math.floor(Math.floor((256 * pos + cur * step) / 256) * (100 - rollback) / 100);
      }
      const last = Math.ceil(256 * (frames - pos) / step) - (this.mode === 'SQ' ? 0 : 1);
      total += last;
      result.push(last, total);
      return result;
    };
    this.compress = hits;

    return true;
  }
}

const makeWereformCalculator = Base => class WereformCalculator extends Base {
  init(...params) {
    const {unit, stats, skill, wclass} = this;

    let mode = this.mode = skill.anim;
    if (mode === 'SQ') {
      const seq = animSequences[skill.seqnum];
      if (seq) {
        this.type = seq.type;
        this.sequence = seq.data[animWeapons.indexOf(wclass)] || seq.data[0];
        if (!this.sequence) return false;
      }
      mode = 'GH';
    } else {
      this.type = animTypes[mode];
    }
    if (this.type !== 'ias') return false;

    this.type = 'wias2';

    const data = this.data = Data.animData(`${unit}${mode}${wclass.toUpperCase()}`) || Data.animData(`${unit}${mode}HTH`);
    if (!data) return false;

    const weapon = this.weapon = (skill.weapsel === 1 && stats.weapon2) || stats.weapon1;
    this.wsm = weapon.weaponspeed;
    let baseaccel = 100 + (weapon.attackrate || 0) - this.wsm;
    if (this.mode === 'SQ') {
      baseaccel -= 30;
    }
    this.wsmlist = [this.wsm];

    this.minaccel = 0;
    this.maxaccel = 120;
    this.accel = this.weapon.weaponias || 0;

    this.speed = data[1];
    this.start = startFrame(unit, mode, wclass);

    this.init2(...params);

    const _oframes = this._frames;

    const wclass1 = Data.items[weapon.baseitem]?.wclass?.toUpperCase() || 'HTH';
    const human = playerCode[this.stats.class];
    const humanData = Data.animData(`${human}A1${wclass1}`) || Data.animData(`${human}A1HTH`);
    const neutral = Data.animData(`${unit}NUHTH`);
    const oias = (weapon.item_fasterattackrate || 0) - (weapon.weaponias || 0);
    if (!humanData || !neutral) return null;

    this._frames = wias => {
      const hframes = Math.floor(256 * humanData[0] / Math.floor(humanData[1] * (100 + wias - weapon.weaponspeed) / 100));
      this.speed = Math.floor(256 * neutral[0] / hframes);
      const dr_accel = 120 * (wias + oias) / (120 + wias + oias) | 0;
      const accel = Math.max(15, Math.min(175, baseaccel + dr_accel));
      return _oframes(accel);
    };

    return true;
  }

  calculate() {
    if (this.error) return null;

    this.result = this._frames(this.accel);
    this.fpa = this.result[this.result.length - 1];

    const minResult = this._frames(this.minaccel);
    const maxResult = this._frames(this.maxaccel);
    if (minResult.every((v, i) => v === maxResult[i])) {
      this.maxaccel = this.minaccel;
    }

    return this;
  }

  reqparams(minaccel, maxaccel, delta=0) {
    if (maxaccel < 0) return [-1];
    return [Math.max(minaccel, 0)];
  }
};

class WhirlwindCalculator extends AnimationCalculator {
  init(weapon) {
    this.weapon = weapon;
    const wclass = this.wclass = Data.items[weapon.baseitem]?.wclass || 'hth';
    this.mode = 'A1';
    this.type = 'ias';

    let data = [7, 256];
    if (wclass === '2ht' || wclass === 'stf') {
      data = [9, 256];
    } else if (wclass === 'ht1') {
      data = [6, 208];
    }

    this.speed = data[1];

    this.wsm = weapon.weaponspeed;
    this.baseaccel = 100 - this.wsm;
    this.varaccel = weapon.weaponias || 0;

    const wc = weaponClassTag(Data.items[weapon.baseitem]);
    this.weaponFilter = weaponFilterSkill(this.skill, wc);
    this.wsmlist = weaponSpeedList(this.weaponFilter, this.wsm);

    this.foinames = ['frames'];
    this.hits = 1;

    this._frames = accel => [Math.ceil(256 * data[0] / Math.floor(data[1] * accel / 100)) - 1];

    return true;
  }
}

const WereformCalculator = makeWereformCalculator(AnimationCalculator);
const WereformRollbackCalculator = makeWereformCalculator(RollbackAnimationCalculator);

const bpMode = {fbr: 'BL', fcr: 'SC', fhr: 'GH'};
export function breakpointList(stats, type) {
  const calc = new AnimationCalculator(stats, {anim: bpMode[type]});
  if (type === 'fbr' && stats.base.state?.[101]) { // holy shield
    calc.baseaccel += 50;
  }
  if (!calc.calculate()) return null;

  return {values: calc.simpleTable(), current: calc.fpa, title: `${calc.unitName} / ${calc.wclass.toUpperCase()}`};
}

export function basicAttackCalculator(stats, skill) {
  const mainhand = new MainHandCalculator(stats, skill);
  if (Data.info.patch && mainhand.wereform) {
    return new AnimationCalculator(stats, skill);
  }
  if (stats.weapon2 && !mainhand.wereform && !mainhand.error) {
    return new DualWieldCalculator(stats, mainhand, new OffHandCalculator(stats));
  }
  return mainhand;
}

export function whirlwindCalculator(stats, skill) {
  const mainhand = new WhirlwindCalculator(stats, skill, stats.weapon1);
  if (stats.weapon2 && !mainhand.error) {
    return new DualWieldCalculator(stats, mainhand, new WhirlwindCalculator(stats, skill, stats.weapon2), true);
  }
  return mainhand;
}

export function defaultAnimation(skill, stats) {
  const anim = new AnimationCalculator(stats, skill);
  //if (!anim.type) return; // no scaling - pointless to display
  return anim.calculate();
}
